import { ApplicationConfig, NgZone } from "@angular/core";
import { PreloadAllModules, provideRouter,  withPreloading } from "@angular/router";
import { ROUTES } from "./app-routing";
import { provideHttpClient, withFetch, withInterceptorsFromDi } from "@angular/common/http";

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: NgZone, useValue: new NgZone({ shouldCoalesceEventChangeDetection: true }) },
    provideRouter(ROUTES,
      withPreloading(PreloadAllModules),

        ),
    provideHttpClient(withInterceptorsFromDi(), withFetch()),

  ],
}


